// extracted by mini-css-extract-plugin
module.exports = {"main":"Logo_main__jVR85","img":"Logo_img__1bNAb"};